export enum LinkOtp {
  Development = 'https://anscweb.anpr.interno.it/ansc/login/otp',
  Staging = ' https://anscweb.anpr.interno.it/ansc/login/otp',
  Production = 'https://anscweb.anpr.interno.it/ansc/login/otp',
}
